import React, { useState, useCallback } from "react";
import { FaRedo, FaQuestion } from "react-icons/fa";
import SectionMenu from "./SectionMenu";

const BAR_HEIGHTS = [12, 20, 28, 22, 16];

const SpaceHUD = ({ isPlaying, onAudioToggle, onRecenter, onPlanetSelect, activeSection }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  const handleMenuSelect = useCallback((section, planetName) => {
    onPlanetSelect?.(section, planetName);
  }, [onPlanetSelect]);

  return (
    <div className="space-hud" role="navigation" aria-label="Navigation HUD">

      {/* Section navigation menu (replaces radar) */}
      <div className="hud-section hud-radar">
        <SectionMenu
          isOpen={menuOpen}
          onToggle={() => setMenuOpen((v) => !v)}
          onSelect={handleMenuSelect}
          activeSection={activeSection}
        />
      </div>

      <div className="hud-divider" />

      {/* Audio visualizer */}
      <div className="hud-section">
        <div
          className="audio-bars"
          onClick={onAudioToggle}
          title={isPlaying ? "Pause music" : "Play music"}
          style={{ cursor: "none" }}
        >
          {BAR_HEIGHTS.map((h, i) => (
            <div
              key={i}
              className={`audio-bar${isPlaying ? " playing" : ""}`}
              style={{ height: `${h}px` }}
            />
          ))}
        </div>
        {isPlaying && (
          <span style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "0.6rem",
            fontWeight: 500,
            color: "rgba(255,179,217,0.7)",
            letterSpacing: "0.05em",
            whiteSpace: "nowrap",
            marginLeft: 6,
          }}>
            Interstellar
          </span>
        )}
      </div>

      <div className="hud-divider" />

      {/* Recenter + Help */}
      <div className="hud-section" style={{ gap: 4 }}>
        <button className="hud-icon-btn" onClick={onRecenter} title="Recenter camera" aria-label="Recenter">
          <FaRedo size={12} />
        </button>
        <div style={{ position: "relative" }}>
          <button
            className="hud-icon-btn"
            onClick={() => setShowHelp((v) => !v)}
            title="Help"
            aria-label="Help"
          >
            <FaQuestion size={11} />
          </button>

          {showHelp && (
            <div style={{
              position: "absolute",
              bottom: "calc(100% + 14px)",
              right: 0,
              width: 220,
              background: "rgba(5,5,8,0.97)",
              backdropFilter: "blur(16px)",
              border: "1px solid rgba(255,179,217,0.1)",
              borderRadius: 14,
              padding: "18px",
              fontFamily: "'DM Sans', sans-serif",
              color: "rgba(255,235,250,0.8)",
              fontSize: "0.82rem",
              lineHeight: 1.7,
              zIndex: 100,
            }}>
              <p style={{ fontFamily: "'Cinzel', serif", fontSize: "0.58rem", letterSpacing: "0.15em", color: "#FFB3D9", marginBottom: 10 }}>
                How to explore
              </p>
              <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                <li>⊕ Click <strong>Explore</strong> to navigate sections</li>
                <li>🪐 Or click any planet directly</li>
                <li>🖱️ Drag to rotate the view</li>
                <li>⚲ Scroll to zoom in or out</li>
                <li>🌌 Zoom out to see the Milky Way</li>
                <li>🎵 Click the bars to play music</li>
              </ul>
              <button
                onClick={() => setShowHelp(false)}
                style={{
                  marginTop: 12,
                  background: "none",
                  border: "1px solid rgba(255,179,217,0.18)",
                  color: "rgba(255,179,217,0.6)",
                  padding: "4px 14px",
                  borderRadius: 20,
                  cursor: "none",
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: "0.72rem",
                  fontWeight: 500,
                }}
              >
                Close
              </button>
            </div>
          )}
        </div>
      </div>

    </div>
  );
};

export default SpaceHUD;
